// src/components/HeaderUser.js
import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Avatar,
  Menu,
  MenuItem,
  Box,
  Button
} from "@mui/material";
import SettingsIcon from '@mui/icons-material/Settings';
import LogoutIcon from '@mui/icons-material/Logout';
import HomeIcon from '@mui/icons-material/Home';
import { Link as RouterLink } from "react-router-dom";

export default function HeaderUser({ user, onLogout, onOpenSettings }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  return (
    <AppBar
      elevation={0}
      color="inherit"
      position="static"
      sx={{ mb: 2, boxShadow: "none", bgcolor: "transparent" }}
    >
      <Toolbar>
        {/* Nút về trang chủ */}
        <Button
          variant="outlined"
          startIcon={<HomeIcon />}
          component={RouterLink}
          to="/"
          sx={{
            fontWeight: 700,
            borderRadius: 3,
            mr: 3,
            bgcolor: "#fff",
            borderColor: "#6366f1",
            color: "#6366f1",
            "&:hover": { bgcolor: "#f1f5fd" }
          }}
        >
          Trang chủ
        </Button>

        <Typography
          variant="h5"
          sx={{
            flexGrow: 1,
            fontWeight: 900,
            color: "#6366f1",
            letterSpacing: 1
          }}
        >
          Trang quản lý {user?.role === 'admin' ? "Admin" : "User"}
        </Typography>
        <Box>
          <IconButton onClick={e => setAnchorEl(e.currentTarget)}>
            <Avatar sx={{ bgcolor: "#6366f1" }}>
              {(user?.name || user?.username || "U")[0].toUpperCase()}
            </Avatar>
          </IconButton>
          <Menu
            open={open}
            anchorEl={anchorEl}
            onClose={() => setAnchorEl(null)}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          >
            <MenuItem onClick={() => { onOpenSettings(); setAnchorEl(null); }}>
              <SettingsIcon sx={{ mr: 1 }} /> Cài đặt
            </MenuItem>
            <MenuItem onClick={() => { onLogout(); setAnchorEl(null); }}>
              <LogoutIcon sx={{ mr: 1 }} /> Đăng xuất
            </MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
}
